import React from 'react';
import PropTypes from 'prop-types';
import compose from '../hoc/compose';
import displayNames from './displayNames';
import TextLabel from './textLabel';

var Tab = function Tab(_ref) {
  var getClassName = _ref.getClassName,
      label = _ref.label,
      shouldTranslate = _ref.shouldTranslate,
      showDotIndicator = _ref.showDotIndicator;
  return /*#__PURE__*/React.createElement("div", {
    className: getClassName('control-tab')
  }, /*#__PURE__*/React.createElement(TextLabel, {
    value: label,
    shouldTranslate: shouldTranslate
  }), showDotIndicator ? /*#__PURE__*/React.createElement("span", {
    key: "showDotIndicator",
    className: "dot-indicator"
  }) : null);
};

Tab.displayName = displayNames.TAB;
Tab.propTypes = {
  value: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  showDotIndicator: PropTypes.bool
};
export default compose(Tab);